<!-- Top loader between routes on navigation -->
<app-slim-loader></app-slim-loader>

<!-- Main app route component -->
<div class="animated fadeIn h-100">
    <router-outlet></router-outlet>
</div>

<!-- Gable AI drawer — only mount on authenticated routes so its service
     chain (GableDrawerService → GableService) never initializes on
     public pages like /sign-up or /auth/password/request-reset-email
     (those break otherwise — see PR #2909 / SD-XXXX for the diagnosis). -->
<app-gable-drawer-host *ngIf="isLoggedIn"></app-gable-drawer-host>

<!-- Ask Penny drawer for homeowners (SD-9449) — self-gates on member context + flag + portal config -->
<app-penny-drawer-host *ngIf="isLoggedIn"></app-penny-drawer-host>

<!-- "Report a bug" drawer — mounted beside the Gable drawer host, behind the
     same authenticated *ngIf. Self-gates internally (super user + the global
     BUG_REPORTER_ENABLED kill switch) via the report-bug button that toggles it. -->
<app-report-bug-drawer-host *ngIf="isLoggedIn"></app-report-bug-drawer-host>

<app-bank-account-kyc-dialog-host *ngIf="isLoggedIn"></app-bank-account-kyc-dialog-host>
<app-create-payable-dialog-host *ngIf="isLoggedIn"></app-create-payable-dialog-host>
<app-payable-update-dialog-host *ngIf="isLoggedIn"></app-payable-update-dialog-host>
<app-check-printing-dialog-host *ngIf="isLoggedIn"></app-check-printing-dialog-host>
<app-download-check-dialog-host *ngIf="isLoggedIn"></app-download-check-dialog-host>
